import PermissionGuard from "@/components/PermissionGuard";
import { EmailRecipientsAddUsersButton } from "@/modules/email-recipients/components/EmailRecipientsAddUsersButton";
import { EmailRecipientsRemoveUsersButton } from "@/modules/email-recipients/components/EmailRecipientsRemoveUsersButton";
import { Operation } from "@/types/permissions";

interface EmailRecipientsToolbarActionsProps {
  emailTypeId?: string;
  onRemove?: () => Promise<void>;
  isRemoveSubmitting: boolean;
  onOpenAdd?: () => void;
  isDisabled?: boolean;
}

export const EmailRecipientsToolbarActions = ({
  emailTypeId,
  onRemove,
  isRemoveSubmitting,
  onOpenAdd,
  isDisabled = false,
}: EmailRecipientsToolbarActionsProps) => {
  return (
    <>
      <PermissionGuard permission={Operation.Update}>
        <EmailRecipientsRemoveUsersButton
          onRemove={onRemove}
          isSubmitting={isRemoveSubmitting}
          isDisabled={isDisabled}
        />
      </PermissionGuard>
      <PermissionGuard permission={Operation.Update}>
        <EmailRecipientsAddUsersButton
          onOpen={onOpenAdd}
          isDisabled={isDisabled || !emailTypeId}
        />
      </PermissionGuard>
    </>
  );
};
